import { gpPersonas } from '../const/gp-personas.const';
import { currentMainState } from '../game-plan.state';

export function createPersonaFilterOptions(): void {
    const state = currentMainState();

    state.personaFilterOptions = [];
    gpPersonas.forEach((value, key) => {
        state.personaFilterOptions.push({
            personaType: key,
            persona: value,
        });
    });
}
